import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: string;
  title: string;
  coverImage: string;
  summary: string;
  category: string;
  author: string;
  publishDate: string;
  readTime: string;
}

const categoryNames: Record<string, string> = {
  movies: '电影',
  'tv-series': '电视剧',
  anime: '动漫',
  variety: '综艺',
  documentary: '纪录片',
  kids: '少儿',
  shorts: '短视频',
};

export default function ArticleCard({ id, title, coverImage, summary, category, author, publishDate, readTime }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[2/1] overflow-hidden">
        <img
          src={coverImage}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          title={`${title} - 欲火视频影视资讯`}
        />
      </div>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 font-medium">
            {categoryNames[category] || category}
          </span>
          <span className="text-xs text-foreground-500">{readTime}</span>
        </div>
        <h3 className="text-base font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {summary}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{author}</span>
          <span>{publishDate}</span>
        </div>
      </div>
    </Link>
  );
}